import React, { useEffect, useState} from "react";
import { amplifyConfig, cognitoUrl } from "src/auth/Amplify";
import { Auth } from '@aws-amplify/auth';
import Amplify from '@aws-amplify/core';
import GlobalCookie from "src/cookie/GlobalCookie";
import config from './cognitoAuthenticationConfig.json';
import { CommonConstants } from '../constant/constants';

Amplify.configure(amplifyConfig);

interface AuthenticatedRouteProps {
    children: React.ReactNode;
}

const hostDomain = window.location.host;
const stageConfig = config[hostDomain];

/**
 * Authenticated Route component to render children after authenticating user via cognito-midway
 */
const AuthenticatedRoute = ({children}: AuthenticatedRouteProps) => {
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
    const [givenName, setGivenName] = useState("");

    const onAuthenticationSuccess = (authenticatedUser) => {
        setIsUserAuthenticated(true);
        (window as any).alias = authenticatedUser.attributes.username;
        setGivenName(authenticatedUser.attributes.given_name);
        window.name = JSON.parse(authenticatedUser.attributes.identities)[0].userId //using unused window prop for alias
        const user_name = authenticatedUser.attributes.preferred_username;
        const employeeId: string = authenticatedUser?.attributes["custom:EMPLOYEE_ID"];
        const cookies = GlobalCookie.getInstance();
        const userToken = cookies.get(CommonConstants.USER_AUTHORIZATION_TOKEN_KEY);
        cookies.set(CommonConstants.USER_AUTHORIZATION_TOKEN_KEY,
            authenticatedUser.signInUserSession.idToken.jwtToken, { path: '/', secure: true });
        cookies.set('USER_NAME',user_name);
        cookies.set("EMPLOYEE_ID", employeeId);
        cookies.set("domain", stageConfig.PARENT_DOMAIN);
        cookies.set("path", "/");
    };

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then((authenticatedUser) => onAuthenticationSuccess(authenticatedUser))
            .catch((error) => {
                console.error('User not Authenticated: ' + error);
                window.location.replace(cognitoUrl);
            });
    }, []);

    if (isUserAuthenticated) {
        return (
            <React.Fragment>
                {/*<div>Hello {givenName}</div>*/}
                <div>{children}</div>
            </React.Fragment>
        );
    } else {
        return <React.Fragment>Not Authenticated {givenName}</React.Fragment>;
    }
};

export default AuthenticatedRoute;